export default __webpack_public_path__ + "static/media/hht2_ani_17.b0365296.png";